module.exports = __webpack_public_path__ + "img/uk-breast-cancer-female.0c326180.png";